import Typography from "@portal/components/atoms/v2/typography";
import { FC, useMemo } from "react";
import { formatNumberTwoDigits } from "@portal/utils/numberFormatters";
import { IFundMorningstarHoldingsProps } from "./types";

const FundMorningstarHoldings: FC<IFundMorningstarHoldingsProps> = ({ morningstarSecurities }) => {
  const holdings = useMemo(() => {
    return morningstarSecurities?.portfolios?.[0].portfolioHoldings?.sort((a, b) => b.weighting - a.weighting);
  }, [morningstarSecurities]);

  const highestHoldingWeight = holdings?.[0].weighting;

  return (
    <ul className="px-2 mt-4 flex flex-col gap-3">
      {holdings?.map(portfolio => {
        const width = highestHoldingWeight ? Math.round((portfolio.weighting / (highestHoldingWeight ?? 1)) * 100) : 0;
        return (
          <li key={portfolio.id} className="flex justify-between items-center gap-2">
            <div className="w-full">
              <div className="flex items-center">
                {portfolio.countryId ? (
                  <span className={`cell-flag cell-flag-${portfolio.countryId.toLowerCase()}`}></span>
                ) : (
                  <span className="w-[14px]"></span>
                )}
                <Typography>{portfolio.securityName}</Typography>
              </div>
              <div className={`bg-blueLight rounded-full h-0.5`} style={{ width: `${width}%` }}></div>
            </div>
            <div className="justify-self-end">
              <Typography>{formatNumberTwoDigits(portfolio.weighting)}%</Typography>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default FundMorningstarHoldings;
